import React, { useEffect, useState } from "react";
import {
  Modal,
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Dimensions,
} from "react-native";
import CText from "../common/CText";
import ModalAlert from "../common/ModalAlert";
import { COLORS } from "../constant";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";

const { width } = Dimensions.get("window");

export const StatementAlert = ({ open, onClose, onConfirm }) => {
  const styles = useStyles();
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  useEffect(() => {
    if (open) {
      setEmail("");
      setIsEmailValid(false);
    }
  }, [open]);
  
  const handleEmailChange = (text) => {
    setEmail(text);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsEmailValid(emailRegex.test(text));
  };

  const handleConfirm = () => {
    onConfirm(email);
    onClose();
  };

  return (
    <Modal transparent visible={open} animationType="fade" onRequestClose={onClose}>
      <View style={styles.overlay}>
        <View style={styles.modal}>
          <Text style={styles.title}>Confirm email address</Text>

          <View style={styles.inputGroup}>
            <CText.disputeCountText style={styles.label}>Email address</CText.disputeCountText>
            <TextInput
              style={styles.input}
              placeholder="Enter email"
              value={email}
              onChangeText={handleEmailChange}
              keyboardType="email-address"
              autoCapitalize="none"
            />
            {!isEmailValid && email.length > 0 && (
              <Text style={{ color: "red", marginTop: 5 }}>Enter a valid email</Text>
            )}
          </View>

          <View style={styles.buttonGroup}>
            <TouchableOpacity
              onPress={handleConfirm}
              style={[styles.confirmButton, { opacity: isEmailValid ? 1 : 0.5 }]}
              disabled={!isEmailValid}
            >
              <Text style={styles.buttonText}>Confirm</Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={onClose} style={styles.dismissButton}>
              <Text style={styles.dismissText}>Dismiss</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export const StatementAlertSendEmail = ({ open, onClose, onSend }) => {
  const styles = useStyles();
  const [email, setEmail] = useState("");
  const [checked, setChecked] = useState(true);
  const [isEmailValid, setIsEmailValid] = useState(false);
 
  useEffect(() => {
    if (open) {
      setEmail("");
      setChecked(true);
      setIsEmailValid(false);
    }
  }, [open]);
  
  const handleEmailChange = (text) => {
    setEmail(text);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsEmailValid(emailRegex.test(text));
  };

  const handleSend = () => {
    onSend(email, checked);
    onClose();
  };

  return (
    <Modal transparent visible={open} animationType="fade" onRequestClose={onClose}>
      <View style={styles.overlay}>
        <View style={styles.modalSend}>
          <View style={styles.sendTitle}>
            <CText.basicInformation>This is taking longer than usual</CText.basicInformation>
          </View>
          <Text style={styles.description}>
            Your report is taking longer to process, please confirm your email below to receive it directly.
          </Text>

          <View style={styles.inputGroup}>
            <View
              style={{
                height: 0,
                borderWidth: 1,
                borderStyle: "dashed",
                borderColor: "#C3C3C3",
                opacity: 1,
                paddingHorizontal: 20,
                marginBottom: 20,
              }}
            />
            <Text style={styles.label}>Email address</Text>
            <TextInput
              style={styles.inputSend}
              placeholder="Enter email"
              value={email}
              onChangeText={handleEmailChange}
              keyboardType="email-address"
              autoCapitalize="none"
            />
            {!isEmailValid && email.length > 0 && (
              <Text style={{ color: "red", marginTop: 5 }}>Enter a valid email</Text>
            )}
            <TouchableOpacity onPress={() => setChecked(!checked)} style={styles.checkboxRow}>
              <View style={styles.checkbox}>{checked && <View style={styles.checked} />}</View>
              <Text style={styles.checkboxText}>Use this email address for future receipts.</Text>
            </TouchableOpacity>
          </View>

          <TouchableOpacity
            onPress={handleSend}
            style={[styles.sendButton, { opacity: isEmailValid ? 1 : 0.5 }]}
            disabled={!isEmailValid}
          >
            <Text style={styles.buttonText}>Send email</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

export const ModalAlertSuccess = () => {
  const styles = useStyles();
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const onCloseModal = () => {
    setAlertModalVisible(false);
  };
  return (
    <>
      {alertModalVisible && (
        <View style={styles.overlayViewStyleAlert}>
          <ModalAlert
            status={"success"}
            title={"alertModal.title"}
            message={"alertModal.message"}
            navigateScreen={"alertModal.navigateScreen"}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      )}
    </>
  );
};

export const StatementNoPreviewAlert = ({ open, onClose, onDownload,onEmail  }) => {
  const styles = useStyles();
    return (
      <Modal transparent visible={open} animationType="fade" onRequestClose={onClose}>
        <View style={styles.overlay}>
          <View style={styles.modal}>
            
            <Text style={[styles.title1,{marginTop:14}]}>Preview Not Available</Text>
  
            <View style={styles.inputGroup1}>
              <CText.disputeCountText style={styles.label1}>Preview is not available for {open} statement, please download the statement</CText.disputeCountText>
            </View>
  
            <View style={styles.buttonGroup1}>
              <TouchableOpacity
                onPress={onDownload}
                style={[styles.confirmButton1]}
              >
                <Text style={styles.buttonText}>Download CSV</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={onEmail}
              >
                <Text style={{color:COLORS.blue,fontSize:14}}>Email</Text>
              </TouchableOpacity>
              <CText.disputeCountText style={styles.label2}>PDF is not available for {open} statement</CText.disputeCountText>


              <TouchableOpacity onPress={onClose} style={styles.dismissButton1}>
                <Text style={styles.dismissText}>Dismiss</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    );
  };
const useStyles = CreateResponsiveStyle({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: 30,
    padding: 30,
    paddingHorizontal: 60,
    width: width - 40,
    height: 300,
    maxWidth: 390,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  title: {
    fontSize: 18,
    fontWeight: "600",
    marginBottom: 50,
    textAlign: "center",
  },
  title1: {
    fontSize: 24,
    fontWeight: "600",
    marginBottom: 20,
    textAlign: "center",
  },
  inputGroup: {
    marginBottom: 20,
    paddingHorizontal: 20,
  },
  inputGroup1: {
    marginBottom: 20,
    justifyContent: "center",
    fontSize: 18,
    alignItems: "center",
    alignSelf: "center",
    paddingHorizontal: 0,
  },
  label: {
    marginBottom: 8,
    fontSize: 14,
    color: "#333",
  },
  label1: {
    marginBottom: 0,
    fontSize: 14,
    color: "#999",
    textAlign: "center",
  },
  label2: {
    marginBottom: 0,
    fontSize: 13,
    color: "#999",
    opacity: 0.75,
    marginTop: 10,
    textAlign: "center",

  },
  input: {
    width: "100%",
    padding: 10,
    fontSize: 14,
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 8,
  },
  buttonGroup: {
    flexDirection: "column",
    gap: 10,
  },
  buttonGroup1: {
    flexDirection: "column",
    gap: 10,
    alignItems: "center",
  },
  confirmButton: {
    backgroundColor: "#BD2D37",
    paddingVertical: 12,
    marginHorizontal: 50,
    borderRadius: 50,
    alignItems: "center",
    top: 20,
  },
  confirmButton1: {
    backgroundColor: "#BD2D37",
    paddingVertical: 12,
    paddingHorizontal: 20,
    marginHorizontal: 50,
    borderRadius: 50,
    alignItems: "center",
    marginTop:20,
  },
  dismissButton: {
    borderRadius: 6,
    paddingVertical: 12,
    alignItems: "center",
    top: 80,
  },
  dismissButton1: {
    borderRadius: 6,
    paddingVertical: 40,
    alignItems: "center",
    top: 10,
  },
  buttonText: {
    color: "#fff",
    fontSize: 16,
  },
  dismissText: {
    color: "#fff",
    fontSize: 16,
  },
  modalSend: {
    backgroundColor: "#fff",
    borderRadius: 20,
    padding: 30,
    width: width - 40,
    maxWidth: 390,
    height: 360,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  sendTitle: {
    fontSize: 18,
    fontWeight: "600",
    marginBottom: 10,
    textAlign: "center",
    color: "#000",
  },
  description: {
    fontSize: 13,
    color: "#555",
    textAlign: "center",
    marginBottom: 30,
  },
  inputSend: {
    width: "100%",
    padding: 12,
    fontSize: 14,
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 8,
    marginBottom: 12,
  },
  checkboxRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  checkbox: {
    width: 18,
    height: 18,
    borderWidth: 1,
    borderColor: "#BD2D37",
    marginRight: 8,
    borderRadius: 4,
    justifyContent: "center",
    alignItems: "center",
  },
  checked: {
    width: 12,
    height: 12,
    backgroundColor: "#BD2D37",
    borderRadius: 2,
  },
  checkboxText: {
    fontSize: 12,
    color: "#333",
  },
  sendButton: {
    backgroundColor: "#BD2D37",
    paddingVertical: 12,
    marginHorizontal: 50,
    borderRadius: 50,
    alignItems: "center",
    top: 20,
  },
},
{
        [DEVICE_SIZES.LG]: {
        
 
        },
        [DEVICE_SIZES.MD]: {
            
        },
        [DEVICE_SIZES.SM]: {
            
        },
        [DEVICE_SIZES.XS]: {
             title1: {
              fontSize: 24,
              fontWeight: "600",
              marginBottom: 30,
              textAlign: "center",
            },
              buttonText: {
              color: "#fff",
              fontSize: 16,
              textAlign: "center",
              textWrap: "nowrap",
            },
              confirmButton1: {
              backgroundColor: "#BD2D37",
              paddingHorizontal: 20,
              marginHorizontal: 50,
              borderRadius: 50,
              alignItems: "center",
              marginTop:10,
            },
              title1: {
              fontSize: 24,
              fontWeight: "600",
              marginBottom: 0,
              textAlign: "center",
            },
            inputGroup1: {
              marginBottom: 0,
              justifyContent: "center",
              fontSize: 18,
              alignItems: "center",
              alignSelf: "center",
              paddingHorizontal: 0,
              marginTop: 10,
            },
              dismissButton1: {
              borderRadius: 6,
              paddingVertical: 50,
              alignItems: "center",
              top: 10,
            },
        }
    }
);
